import { useState } from 'react'

import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'

import styles from './index.module.css'

library.add(faChevronDown, faChevronUp)

const ShowMore = ({ children, buttonCustomClass = '' }) => {
  const [isVisible, setIsVisible] = useState(false)
  const labelText = isVisible ? (
    <Trans>Leggi di meno</Trans>
  ) : (
    <Trans>Leggi di più</Trans>
  )

  return (
    <>
      {isVisible && children}
      <button
        className={classNames(styles.showButton, buttonCustomClass)}
        onClick={() => setIsVisible((prev) => !prev)}
      >
        <Paragraph className={styles.showButtonLabel}>{labelText}</Paragraph>
        <FontAwesomeIcon
          icon={['fas', isVisible ? 'chevron-up' : 'chevron-down']}
          className={styles.showButtonIcon}
        />
      </button>
    </>
  )
}

export default ShowMore
